import * as types from './constants';

// Get Shopify Collections
export const getShopifyCollectionsRequest = data => (
  { type: types.GET_SHOPIFY_COLLECTIONS_REQUEST, payload: data }
);

export const getShopifyCollectionsDone = data => (
  { type: types.GET_SHOPIFY_COLLECTIONS_DONE, payload: data }
);

export const getShopifyCollectionsFailed = errors => (
  { type: types.GET_SHOPIFY_COLLECTIONS_FAILED, payload: errors }
);

export const getShopifyCollectionsReset = () => (
  { type: types.GET_SHOPIFY_COLLECTIONS_RESET }
);

// Operations
// `url` is the `next` URL of the last loaded page; the request effect picks it up to load that page.
export const shopifyCollectionsSetPageUrl = url => (
  { type: types.SHOPIFY_COLLECTIONS_SET_PAGE_URL, payload: url }
);
